import {requestHelpers, FormFieldHelpers} from '../../helpers';

const actions = {
    GET_CURRENT_JOB: 'GET_CURRENT_JOB',
    SET_CURRENT_JOB: 'SET_CURRENT_JOB',
    RESET_CURRENT_JOB :'RESET_CURRENT_JOB',
    GET_JOBS: 'GET_JOBS',
    SET_JOBS: 'SET_JOBS',
    CLEAR_JOBS: 'CLEAR_JOBS',
    GET_MY_JOBS: 'GET_MY_JOBS',
    SET_MY_JOBS: 'SET_MY_JOBS',
    GET_PREMIUM_JOBS: 'GET_PREMIUM_JOBS',
    SET_PREMIUM_JOBS: 'SET_PREMIUM_JOBS',
    GET_HOME_TILE_JOBS: 'GET_HOME_TILE_JOBS',
    SET_HOME_TILE_JOBS: 'SET_HOME_TILE_JOBS',
    GET_SEARCH: 'GET_SEARCH',
    SET_SEARCH: 'SET_SEARCH',
    SET_SEARCH_INITIAL_VALUES: 'SET_SEARCH_INITIAL_VALUES',
    RESET_SEARCH_INITIAL_VALUES: 'RESET_SEARCH_INITIAL_VALUES',
    LOG_EXTERNAL: 'LOG_EXTERNAL',
    GET_MY_JOB_APPLICATIONS: "GET_MY_JOB_APPLICATIONS",
    SET_MY_JOB_APPLICATIONS: "SET_MY_JOB_APPLICATIONS",
    UPDATE_APPLICATION_COMPLETE: "UPDATE_APPLICATION_COMPLETE",
    SET_APPLICATION_STATUSES: "SET_APPLICATION_STATUSES",
    UPDATE_APPLICATION_STATUS: "UPDATE_APPLICATION_STATUS",
    GET_ALL_SAVED_SEARCHES: 'GET_ALL_SAVED_SEARCHES',
    SET_ALL_SAVED_SEARCHES: 'SET_ALL_SAVED_SEARCHES',
    SAVED_SEARCH_ERROR: 'SAVED_SEARCH_ERROR',
    DELETE_SAVED_SEARCH: 'DELETE_SAVED_SEARCH',
    ALL_SAVED_SEARCHES_ERROR: 'ALL_SAVED_SEARCHES_ERROR',
    SAVE_SEARCH: 'SAVE_SEARCH',
    SAVE_SEARCH_ERROR: 'SAVE_SEARCH_ERROR',
    GET_FAVOURITE_JOBS: "GET_FAVOURITE_JOBS",
    SET_FAVOURITE_JOBS: "SET_FAVOURITE_JOBS",
    ADD_JOB_TO_FAVOURITES: "ADD_JOB_TO_FAVOURITES",
    REMOVE_JOB_FROM_FAVOURITES: "REMOVE_JOB_FROM_FAVOURITES",
    SET_JOBS_INITIAL_VALUES: "SET_JOBS_INITIAL_VALUES",
    SET_JOB_ALERT: "SET_JOB_ALERT",
    HANDLE_SAVE_SEARCH: 'HANDLE_SAVE_SEARCH',
};

function getCurrentJob(jobId) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_CURRENT_JOB,
            jobId,
        });
        requestHelpers
            .authenticatedGetRequest(`/jobs/${ jobId }/uk-us`)
            .then((response) => {
                dispatch({
                    type: actions.SET_CURRENT_JOB,
                    job: response.data,
                });
            });
    }
}

function resetCurrentJob( ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.RESET_CURRENT_JOB,
        } )
    }
}

function getJobs( page, options = null ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_JOBS,
        });

    let newOptions = {};
    let newOptionsWithLabels = {};

    if (!options) {
      newOptions = options = {};
    } else {
      newOptions = {...options};
      newOptionsWithLabels = {...options};
    }

    if (options.country_id) {
        newOptions.country_id = options.country_id
        newOptionsWithLabels.country_id = options.country_id;
    }

    if (options.region_id) {
      newOptions.region_id = FormFieldHelpers
        .extractValue(options.region_id);
        newOptionsWithLabels.region_id = options.region_id;
    }

    if (options.remuneration_type_id) {
      newOptions.remuneration_type_id = FormFieldHelpers
        .extractValue(options.remuneration_type_id);
        newOptionsWithLabels.remuneration_type_id = options.remuneration_type_id;
    }

    if (options.sector_id) {
      newOptions.sector_id = FormFieldHelpers
        .extractValue(options.sector_id);
        newOptionsWithLabels.sector_id = options.sector_id;
    }

    if (options.industry_id) {
      newOptions.industry_id = FormFieldHelpers
        .extractValue(options.industry_id);
        newOptionsWithLabels.industry_id = options.industry_id;
    }


    if (options.expertise_id) {
      newOptions.expertise_id = FormFieldHelpers
        .extractValue(options.expertise_id);
        newOptionsWithLabels.expertise_id = options.expertise_id;
    }

    if (!page) {
      newOptions.page = 1;
      newOptionsWithLabels.page = 1
    } else {
      newOptions.page = page;
      newOptionsWithLabels.page = page;
    }

    dispatch({
      type: actions.SET_SEARCH_INITIAL_VALUES,
      options: newOptionsWithLabels,
    });

    requestHelpers
      .authenticatedGetRequest('/jobs', newOptions)
      .then((response) => {
        dispatch({
          type: actions.SET_JOBS,
          jobs: response.data,
          pagination: response.meta,
        //   options: newOptions,
          options: newOptionsWithLabels,
        });
      });
  }
}

function getMyJobs(personId, page) {

    return (dispatch) => {
        dispatch({
            type: actions.GET_MY_JOBS,
        });

        let newOptions = {};
        let newOptionsWithLabels = {};

        newOptions.person_id = personId;
        newOptionsWithLabels.person_id = personId;

        if (!page) {
            newOptions.page = 1;
            newOptionsWithLabels.page = 1;
        } else {
            newOptions.page = page;
            newOptionsWithLabels.page = page;
        }

        requestHelpers
            .authenticatedLaravelGetRequest(`https://mailservice2.intouchnetworks.com/api/jobs/me`, newOptions)
            .then((response) => {
                dispatch({
                    type: actions.SET_MY_JOBS,
                    myJobs: response.data,
                    options: newOptionsWithLabels,
                });

            });
    }
}

function updateJobOptions(options) {
    return (dispatch) => {
        dispatch({
            type: actions.SET_JOBS_INITIAL_VALUES,
            options,
        });
    }
}

function getMyJobApplications(options, page, personId, jobId = null ) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_MY_JOB_APPLICATIONS,
        });

        let newOptions;

        if (!options || options === null) {
            newOptions = options = {};
        } else {
            newOptions = {...options};
        }

        if (!page) {
            newOptions.page = 1;
        } else {
            newOptions.page = page;
        }

        if (jobId) {
            newOptions.job_id = jobId;
        }
        requestHelpers
            .authenticatedGetRequest(`/people/${ personId }/jobs/applications`, newOptions)
            .then((response) => {
                dispatch({
                    type: actions.SET_MY_JOB_APPLICATIONS,
                    myApplications: response.data,
                    pagination: response.meta,
                    options,
                });

            });
    }
}

function getApplicationStatus() {
    return (dispatch) => {
        requestHelpers
            .authenticatedGetRequest(`/jobs/application-statuses`)
            .then((response) => {
                dispatch({
                    type: actions.SET_APPLICATION_STATUSES,
                    status: response.data,
                });

            });
    }
}

function updateApplicationToComplete(personId, applied, jobId) {
    return (dispatch) => {
        if (applied === 1) {
            requestHelpers
                .authenticatedPostRequest(`/people/${ personId }/jobs/applications/${ jobId }/complete`)
                .then((response) => {
                    dispatch({
                        type: actions.UPDATE_APPLICATION_COMPLETE,
                    })
                })
        } else {
            requestHelpers
                .authenticatedPostRequest(`/people/${ personId }/jobs/applications/${ jobId }`, {}, "DELETE")
                .then((response) => {
                    dispatch({
                        type: actions.UPDATE_APPLICATION_COMPLETE,
                    })
                })
        }
    }
}

function updateApplicationStatus(personId, status, jobId) {
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/people/${ personId }/jobs/applications/${ jobId }/status`, {status: status}, "PUT")
            .then((response) => {
                dispatch({
                    type: actions.UPDATE_APPLICATION_STATUS,
                })
            })
    }
}

function unmountJobs() {

    return (dispatch) => {
        dispatch({
            type: actions.CLEAR_JOBS,
        });
    }

}

function getFavouriteJobs(options, page, personId) {

    return (dispatch) => {
        dispatch({
            type: actions.GET_JOBS
        });

        let newOptions;
        let newOptionsWithLabels = {};

        if (!options || options === null) {
            newOptions = options = {};
        } else {
            newOptions = {...options};
            newOptionsWithLabels = {...options};
        }

        if (!page) {
            newOptions.page = 1;
            newOptionsWithLabels.page = 1;
        } else {
            newOptions.page = page;
            newOptionsWithLabels.page = page;
        }

        dispatch({
            type: actions.SET_SEARCH_INITIAL_VALUES,
            options: newOptionsWithLabels,
        });

        requestHelpers
            .authenticatedGetRequest(`/people/${ parseInt(personId, 10) }/favourite-jobs`, newOptions)
            .then((response) => {
                dispatch({
                    type: actions.SET_FAVOURITE_JOBS,
                    jobs: response.data,
                    // favouriteJobs: response.data,
                    pagination: response.meta,
                    options: newOptionsWithLabels,
                });

            });
    }
}

function resetJobSearchInitialValues() {
    return (dispatch) => {
        dispatch({
            type: actions.RESET_SEARCH_INITIAL_VALUES,
        });
    }
}

function getPremiumJobs() {

    return (dispatch) => {
        dispatch({
            type: actions.GET_PREMIUM_JOBS
        });

        requestHelpers
            .authenticatedGetRequest('/jobs/premium')
            .then((response) => {
                dispatch({
                    type: actions.SET_PREMIUM_JOBS,
                    premium_jobs: response.data,
                })
            })
    }
}

function logExternal(jobId) {
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/jobs/${ jobId }/apply`)
            .then((response) => {
                dispatch({
                    type: actions.LOG_EXTERNAL,
                })
            })
    }
}

function addJobToFavourites(personId, jobId, index, skip) {
    return dispatch => {
        requestHelpers
            .authenticatedPostRequest( `/people/${ personId }/favourite-job/${ jobId }` )
            .then( response => {
                dispatch({
                    type: actions.ADD_JOB_TO_FAVOURITES,
                    jobId,
                    index,
                    skip
                })
            })
    }
}

function removeJobFromFavourites(personId, jobId, index, skip) {
    return dispatch => {
        requestHelpers
            .authenticatedPostRequest( `/people/${ personId }/favourite-job/${ jobId }`, {}, "DELETE" )
            .then( response => {
                dispatch({
                    type: actions.REMOVE_JOB_FROM_FAVOURITES,
                    jobId,
                    index,
                    skip
                })
            })
    }
}

function getHomeTileJobs() {
    return dispatch => {
        dispatch({
            type: actions.GET_HOME_TILE_JOBS
        });

        requestHelpers
            .authenticatedGetRequest('/jobs/home')
            .then(response => {
                dispatch({
                    type: actions.SET_HOME_TILE_JOBS,
                    jobs_homepage: response.data,
                })
            })
    };
}

function saveSearch( personId, searchValues, flag ) {
    return dispatch => {
        const completeData = { ...searchValues };

        completeData.save = flag ? 1 : 0;

        if (searchValues.country_id) {
          completeData.country_id = FormFieldHelpers
            .extractValue(completeData.country_id);
        }

        if (searchValues.region_id) {
          completeData.region_id = FormFieldHelpers
            .extractValue(completeData.region_id);
        }

    if (searchValues.remuneration_type_id) {
      completeData.remuneration_type_id = FormFieldHelpers
        .extractValue(completeData.remuneration_type_id);
    }

    if (searchValues.sector_id) {
      completeData.sector_id = FormFieldHelpers
        .extractValue(completeData.sector_id);
    }

    if (searchValues.industry_id) {
      completeData.industry_id = FormFieldHelpers
        .extractValue(completeData.industry_id);
    }

    if (searchValues.expertise_id) {
      completeData.expertise_id = FormFieldHelpers
        .extractValue(completeData.expertise_id);
    }

    if (searchValues.tag_id) {
      completeData.tag_id = FormFieldHelpers
        .extractValue(completeData.tag_id);
    }


    requestHelpers
      .authenticatedPostRequest( `/people/${personId}/jobs/save-search`, completeData )
      .then(response => {
        const namedSearchSaveSuccess = (response.success && flag) ? response.success : null;
        dispatch({
          type: actions.SAVE_SEARCH,
          saveSuccessful: namedSearchSaveSuccess,
        })
      })

    .catch((error) => {
      return dispatch({
        type: actions.SAVE_SEARCH_ERROR,
        notSavedError: error,
      });
    })
    }
}

function getAllSavedSearches(personId, options, page) {
    return dispatch => {
        dispatch({
            type: actions.GET_ALL_SAVED_SEARCHES,
            isFetching: true,
            isError: false,
        });

        let newOptions;

        if (!options || options === null) {
            newOptions = options = {};
        } else {
            newOptions = {...options};
        }

        if (!page) {
            newOptions.page = 1;
        } else {
            newOptions.page = page;
        }

            requestHelpers
            .authenticatedGetRequest(`/people/${ personId }/jobs/saved-searches`, newOptions)
            .then(response => {
                dispatch({
                    type: actions.SET_ALL_SAVED_SEARCHES,
                    savedSearches: response.data,
                    pagination: response.meta,
                    options,
                    isFetching: false,
                    isError: false,
                })
            })
            .catch((error) => {
                return dispatch({
                    type: actions.ALL_SAVED_SEARCHES_ERROR,
                    isFetching: false,
                    isError: true,
                })
            })
    }
}

function deleteSavedSearch(personId, searchId) {
    return dispatch => {

        requestHelpers
            .authenticatedPostRequest(`/people/${ personId }/jobs/search/${ searchId }`, {}, 'DELETE')
            .then((response) => {
                dispatch({
                    type: actions.DELETE_SAVED_SEARCH,
                    removedSearchId: searchId
                })
            })
            .catch((error) => {
                console.log('LOG: ERROR', error);
            })
    }
}

function setAlert( personId, searchId, flag, index ) {
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/people/${ personId }/jobs/saved-search/${ searchId }/alert`, {action: flag})
            .then((response) => {
                dispatch({
                    type: actions.SET_JOB_ALERT,
                    index,
                    flag,
                });
            });
    };
}

function handleSaveSearch(flag) {
    return (dispatch) => {
        dispatch({
          type: actions.HANDLE_SAVE_SEARCH,
          open: flag,
        })
    }
}

module.exports = {
  actions,
  getCurrentJob,
  resetCurrentJob,
  getJobs,
  getMyJobs,
  resetJobSearchInitialValues,
  getPremiumJobs,
  getHomeTileJobs,
  logExternal,
  getMyJobApplications,
  updateApplicationToComplete,
  getApplicationStatus,
  updateApplicationStatus,
  getFavouriteJobs,
  addJobToFavourites,
  removeJobFromFavourites,
  unmountJobs,
  getAllSavedSearches,
  saveSearch,
  updateJobOptions,
  deleteSavedSearch,
  setAlert,
  handleSaveSearch
};



// WEBPACK FOOTER //
// src/client/actions/jobs/jobs.js